import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7db8dc30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-programs-index" }
const _hoisted_2 = { class: "box-banner" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "box-search" }
const _hoisted_5 = { class: "box-title" }
const _hoisted_6 = { class: "section-name" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "program" }

import { onMounted, reactive, ref } from 'vue';
  import { request } from '@/utils';
  import { Collection } from '@/stores';
  import { useRouter } from 'vue-router';
  import { useI18n } from 'vue-i18n';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t } = useI18n();
  const breadcurmbRoutes = [
    {
      name: t('Home'),
      to: '/'
    },
    {
      name: t('Program')
    }
  ];

  const router = useRouter();
  const keyword = ref('');
  const store = reactive<Collection>(
    new Collection({
      params: {
        per_page: 6
      },
      fetch(params = {}) {
        return request.get('/programs', { params });
      }
    })
  );
  onMounted(
    () => store.fetchData(store.params)
  );

  const handleSearch = (keyword: string) => {
    router.push({ name: 'programs.all', query: { keyword  } });
  };


return (_ctx: any,_cache: any) => {
  const _component_AppBanner = _resolveComponent("AppBanner")!
  const _component_AppBreadcurmb = _resolveComponent("AppBreadcurmb")!
  const _component_AppEmptyView = _resolveComponent("AppEmptyView")!
  const _component_AppSearch = _resolveComponent("AppSearch")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppCardProgram = _resolveComponent("AppCardProgram")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_AppBanner, {
        image: require('./images/program-banner.jpg'),
        title: _unref(t)('banner_title'),
        desc: _unref(t)('banner_desc')
      }, null, 8, ["image", "title", "desc"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_AppBreadcurmb, { routes: breadcurmbRoutes }),
      (_unref(store).isEmpty)
        ? (_openBlock(), _createBlock(_component_AppEmptyView, { key: 0 }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_AppSearch, {
                modelValue: keyword.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event)),
                onSearch: handleSearch
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h4", _hoisted_6, _toDisplayString(_unref(t)('Program')), 1),
              (_unref(store).meta.next_page)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    class: "more",
                    to: { name: 'programs.all' }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('more')) + "> ", 1)
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).data, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "col-6 col-md-4"
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_AppCardProgram, {
                      sm: "",
                      program: item
                    }, null, 8, ["program"])
                  ])
                ]))
              }), 128))
            ])
          ], 64))
    ])
  ]))
}
}

})